/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M9.5 14.5L14.5 9.5M9.5 9.5L14.5 14.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 13.499 2.33015 14.921 2.9214 16.1973C3.38829 17.2052 3.83022 18.0644 3.50454 19.1977C3.34789 19.7429 2.95529 20.2798 2.90866 20.8475C2.85534 21.4967 3.42708 22.0228 4.06965 21.9157C5.3779 21.6977 6.0076 20.6574 7.52552 21.0144C7.69003 21.0531 8.11879 21.2065 8.97627 21.5132C9.88354 21.8377 10.8606 22 12 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 13.499 2.33015 14.921 2.9214 16.1973C3.38829 17.2052 3.83022 18.0644 3.50454 19.1977C3.34789 19.7429 2.95529 20.2798 2.90866 20.8475C2.85534 21.4967 3.42708 22.0228 4.06965 21.9157C5.3779 21.6977 6.0076 20.6574 7.52552 21.0144C7.69003 21.0531 8.11879 21.2065 8.97627 21.5132C9.88354 21.8377 10.8606 22 12 22Z"
				fill="currentColor"
			/>
			<path
				d="M9.5 14.5L12 12M12 12L14.5 9.5M12 12L9.5 9.5M12 12L14.5 14.5M22 12C22 17.5228 17.5228 22 12 22C10.8606 22 9.88354 21.8377 8.97627 21.5132C8.11879 21.2065 7.69003 21.0531 7.52552 21.0144C6.0076 20.6574 5.3779 21.6977 4.06965 21.9157C3.42708 22.0228 2.85534 21.4967 2.90866 20.8475C2.95529 20.2798 3.34789 19.7429 3.50454 19.1977C3.83022 18.0644 3.38829 17.2052 2.9214 16.1973C2.33015 14.921 2 13.499 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.31934 16.6807C2.29299 16.6244 2.26675 16.5684 2.24087 16.5125C1.60482 15.1395 1.25 13.6102 1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C10.786 22.75 9.72211 22.5765 8.72366 22.2194C7.83036 21.8998 7.46428 21.7705 7.35382 21.7445C6.68259 21.5866 6.0471 21.8925 5.41652 22.196C5.00937 22.392 4.60427 22.587 4.1929 22.6555C3.06842 22.8429 2.06787 21.9222 2.16118 20.7861C2.19452 20.3801 2.35166 20.0332 2.50977 19.6842C2.61162 19.4593 2.71389 19.2336 2.78372 18.9906C3.01855 18.1734 2.66113 17.4103 2.31934 16.6807ZM10.0303 8.96967C9.73744 8.67678 9.26256 8.67678 8.96967 8.96967C8.67678 9.26256 8.67678 9.73744 8.96967 10.0303L10.9393 12L8.96967 13.9697C8.67678 14.2626 8.67678 14.7374 8.96967 15.0303C9.26256 15.3232 9.73744 15.3232 10.0303 15.0303L12 13.0607L13.9697 15.0303C14.2626 15.3232 14.7374 15.3232 15.0303 15.0303C15.3232 14.7374 15.3232 14.2626 15.0303 13.9697L13.0607 12L15.0303 10.0303C15.3232 9.73744 15.3232 9.26256 15.0303 8.96967C14.7374 8.67678 14.2626 8.67678 13.9697 8.96967L12 10.9393L10.0303 8.96967Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M4 5.99902C2.74418 7.67051 2 9.74835 2 12C2 13.499 2.33015 14.921 2.9214 16.1973C3.38829 17.2052 3.83022 18.0644 3.50454 19.1977C3.34789 19.7429 2.95529 20.2798 2.90866 20.8475C2.85534 21.4967 3.42708 22.0228 4.06965 21.9157C5.3779 21.6977 6.0076 20.6574 7.52552 21.0144C7.69003 21.0531 8.11879 21.2065 8.97627 21.5132C9.88354 21.8377 10.8606 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C10.5778 2 9.22492 2.29689 8 2.83209M9.5 14.5L12 12M12 12L14.5 9.5M12 12L9.5 9.5M12 12L14.5 14.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M9.5 14.5L12 12M12 12L14.5 9.5M12 12L9.5 9.5M12 12L14.5 14.5M22 12C22 17.5228 17.5228 22 12 22C10.8606 22 9.88354 21.8377 8.97627 21.5132C8.11879 21.2065 7.69003 21.0531 7.52552 21.0144C6.0076 20.6574 5.3779 21.6977 4.06965 21.9157C3.42708 22.0228 2.85534 21.4967 2.90866 20.8475C2.95529 20.2798 3.34789 19.7429 3.50454 19.1977C3.83022 18.0644 3.38829 17.2052 2.9214 16.1973C2.33015 14.921 2 13.499 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M2.24087 16.5125C2.60252 17.2931 3.03665 18.1104 2.78372 18.9906C2.60548 19.6108 2.216 20.1186 2.16118 20.7861C2.06787 21.9222 3.06842 22.8429 4.1929 22.6555C5.24137 22.4808 6.24918 21.4847 7.35382 21.7445C7.46428 21.7705 7.83036 21.8998 8.72366 22.2194C9.72211 22.5765 10.786 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 13.6102 1.60482 15.1395 2.24087 16.5125Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.96967 8.96967C9.26256 8.67678 9.73744 8.67678 10.0303 8.96967L12 10.9393L13.9697 8.96967C14.2626 8.67678 14.7374 8.67678 15.0303 8.96967C15.3232 9.26256 15.3232 9.73744 15.0303 10.0303L13.0607 12L15.0303 13.9697C15.3232 14.2626 15.3232 14.7374 15.0303 15.0303C14.7374 15.3232 14.2626 15.3232 13.9697 15.0303L12 13.0607L10.0303 15.0303C9.73744 15.3232 9.26256 15.3232 8.96967 15.0303C8.67678 14.7374 8.67678 14.2626 8.96967 13.9697L10.9393 12L8.96967 10.0303C8.67678 9.73744 8.67678 9.26256 8.96967 8.96967Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
